import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material";
import BryxColors from "../../types/theme";
import BryxBox from "../BryxBox";
import BryxIcon from "../BryxIcon/BryxIcon";
import BryxTypography from "../BryxTypography";
export var BryxToastLevels;
(function (BryxToastLevels) {
    BryxToastLevels[BryxToastLevels["success"] = 0] = "success";
    BryxToastLevels[BryxToastLevels["info"] = 1] = "info";
    BryxToastLevels[BryxToastLevels["warning"] = 2] = "warning";
    BryxToastLevels[BryxToastLevels["error"] = 3] = "error";
})(BryxToastLevels || (BryxToastLevels = {}));
const levelColorMap = {
    success: BryxColors.notify("light", "success"),
    info: BryxColors.notify("light", "info"),
    warning: BryxColors.notify("light", "warning"),
    error: BryxColors.notify("light", "critical"),
};
const levelIconMap = {
    success: "check_circle",
    info: "info_rounded",
    warning: "error",
    error: "error",
};
const BryxToast = styled(({ level, title, message, dismissible, dismissCallback, ...rest }) => {
    return (_jsxs(BryxBox, { ...rest, isFlex: true, centerAlignItems: true, sx: {}, children: [_jsxs(BryxBox, { className: "icon-container", isFlex: true, centerJustifyContent: true, fullHeight: true, children: [_jsx(BryxBox, { className: "level-icon", isFlex: true, column: true, centerJustifyContent: true, fullHeight: true, children: _jsx(BryxIcon, { iconName: levelIconMap[level], mdIconSize: true }) }), _jsx(BryxBox, { className: "level-bar", isFlex: true, column: true, centerJustifyContent: true, fullHeight: true })] }), _jsxs(BryxBox, { className: "toast-body", isFlex: true, column: true, centerJustifyContent: true, fullHeight: true, children: [_jsx(BryxTypography, { className: "toast-title ellipsis", variant: "h4", children: title }), _jsx(BryxTypography, { className: "toast-message ellipsis", variant: "body1", children: message })] }), dismissible && (_jsx(BryxBox, { className: "dismiss", isFlex: true, column: true, centerJustifyContent: true, fullHeight: true, children: _jsx(BryxIcon, { onClick: () => dismissCallback(), iconName: "close", mdIconSize: true }) }))] }));
})(({ level }) => ({
    borderRadius: "4px",
    padding: "16px 24px",
    height: "75px",
    width: "325px",
    ".icon-container": {
        width: "20%",
    },
    ".level-icon": {
        color: levelColorMap[level],
    },
    ".level-bar": {
        content: `" "`,
        width: "1px",
        borderRadius: "1px",
        border: `1px solid ${levelColorMap[level]}`,
        margin: "0 16px",
    },
    ".toast-body": {
        overflow: "hidden",
        width: "auto",
    },
    ".toast-title": {
        color: levelColorMap[level],
    },
    ".toast-message": {
        color: BryxColors.notify("light", "inactive"),
    },
    ".ellipsis": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "auto",
    },
    ".dismiss": {
        alignItems: "flex-end",
        color: BryxColors.specialColor("light").greyButGray,
        width: "20%",
        "& > svg": {
            cursor: "pointer",
        },
    },
}));
export default BryxToast;
